import { FixedAsset } from '../../accounting/fixed-asset';
import { Liability } from '../../accounting/liability';
import { Equity } from '../../accounting/equity';
import { UnifiedBankAccount } from '../../unified-bank-account';

export class Transfer
{
    id: number;
    transactionId: number;
    sourceId: number;
    sourceType: string;
    destinationId: number;
    destinationType: string;

    source?: FixedAsset | Liability | Equity | UnifiedBankAccount = null;
    destination?: FixedAsset | Liability | Equity | UnifiedBankAccount = null;

    constructor(transfer: any) {
        this.id = transfer.id || null;
        this.transactionId = transfer.transactionId || null;
        this.sourceId = transfer.sourceId || null;
        this.sourceType = transfer.sourceType || null;
        this.destinationId = transfer.destinationId || null;
        this.destinationType = transfer.destinationType || null;

        if (transfer.source) {
            this.source = this.resolveEntity(transfer.sourceType, transfer.source);
        }

        if (transfer.destination) {
            this.destination = this.resolveEntity(transfer.destinationType, transfer.destination);
        }
    }

    private resolveEntity(type: string, data: any): FixedAsset | Liability | Equity | UnifiedBankAccount {
        if (type?.includes('Asset')) {
            return new FixedAsset(data);
        } else if (type?.includes('Liability')) {
            return new Liability(data);
        } else if (type?.includes('Equity')) {
            return new Equity(data);
        } else if (type?.includes('UnifiedBankAccount')) {
            return new UnifiedBankAccount(data);
        }
        return data;
    }
}
